"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiKeyClientSecretInvalidError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "ApiKeyClientSecretInvalid";
const messageKey = "driver.apiKey.error.clientSecretInvalid";
class ApiKeyClientSecretInvalidError extends teamsfx_api_1.UserError {
    constructor(actionName) {
        super({
            source: actionName,
            name: errorCode,
            message: localizeUtils_1.getDefaultString(messageKey, constants_1.maxSecretPerApiKey),
            displayMessage: localizeUtils_1.getLocalizedString(messageKey, constants_1.maxSecretPerApiKey),
        });
    }
}
exports.ApiKeyClientSecretInvalidError = ApiKeyClientSecretInvalidError;
//# sourceMappingURL=apiKeyClientSecretInvalid.js.map